<!-- 
Shows a preview of the expected effect of running the import in-scope providers task.
-->
<template>
  <div v-if="loaded" ref="changesContainer">
    <v-alert 
      v-if="task.warning"
      :dismissible="false" color="primary" 
      type="info" icon="event_note" class="mb-3 d-inline-flex" outline
    >
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
      <p class="caption ma-0 grey--text text--darken-4" v-html="highlightWarning(task.warning)"/>
    </v-alert>
    <div v-if="anyChanges">
      <p class="mt-2">Running this task will:</p>
      <v-card flat style="max-height: 200px;" class="email-content">
        <v-card-text class="pt-1 pl-2">
          <div v-for="(item, index) in previewData.details" ref="items" :key="index">
            {{ item }}
          </div>
        </v-card-text>
      </v-card>
      <v-btn flat class="ma-0 mt-2 caption pl-2 pr-2" @click="copyToClipboard">
        <v-icon class="mr-1">queue</v-icon>
        Copy to clipboard
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { deepCopyAxiosException } from "@/store/helpers";

export default {
  props: {
    task: {
      type: Object,
      required: true
    },
    levyCollectionId: {
      type: Number,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      previewData: {},
      loaded: false
    };
  },
  computed: {
    anyChanges() {
      return this.previewData && (this.previewData.added > 0 || this.previewData.removed > 0);
    }
  },
  watch: {
    show: {
      immediate: true,
      handler() {
        if (this.show) {
          this.loaded = false;
          this.load();
        }
      }
    }
  },
  methods: {
    load: async function() {
      try {
        const url = `/api/levy-collections/${this.levyCollectionId}/statistics/import-in-scope-providers`;
        const { data } = await axios.get(url);
        this.previewData = data;
        this.loaded = true;
        this.$emit("loaded");
      } catch (e) {
        this.$store.commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      }
    },
    copyToClipboard() {
      const data = this.previewData.details.join("\n");
      this.$copyText(data, this.$refs.changesContainer);
      this.$store.commit(SHOW_NOTIFICATION, "In-scope import change details have been copied to the clipboard.");
    },
    highlightWarning(text) {
      var warningPos = text.indexOf("WARNING -");
      if (warningPos < 0) {
        return text;
      }
      var baseText = text.substr(0, warningPos);
      var warning = text.substr(warningPos);
      return baseText + "<span class='error--text'>" + warning + "</span>";
    }
  }
};
</script>
